module.exports = __webpack_public_path__ + "img/signup-coins-2.24057385.png";